/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   Detail constants
 */

export const MOBILE_VIEW = '@@nzr/Detail/MOBILE_VIEW'

export const CLEAR_DETAIL = '@@nzr/Detail/CLEAR_DETAIL'

export const RECEIVE_ACTIVE_LISTINGS = '@@nzr/Detail/RECEIVE_ACTIVE_LISTINGS'
export const RECEIVE_INACTIVE_LISTINGS = '@@nzr/Detail/RECEIVE_INACTIVE_LISTINGS'

export const RECEIVE_DIL_ADDRESSES = '@@nzr/Detail/RECEIVE_DIL_ADDRESSES'

export const RECEIVE_DIL_BUILDINGS = '@@nzr/Detail/RECEIVE_DIL_BUILDINGS'
export const CLOSE_FLOORPLAN_MODAL = '@@nzr/Detail/CLOSE_FLOORPLAN_MODAL'
export const OPEN_FLOORPLAN_MODAL = '@@nzr/Detail/OPEN_FLOORPLAN_MODAL'

export const SET_IS_ADDRESS = '@@nzr/Detail/SET_IS_ADDRESS'
export const SET_NEW_GALLERY_UX = '@@nzr/Detail/SET_NEW_GALLERY_UX'

export { RECEIVE_LOCATION_SCHOOLS } from '../modules/schools/constants/index'
